module.exports = __webpack_public_path__ + "static/media/toggle-top-settng-menu.6b9a4e2a.svg";